import { Component, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { ApplicationState, getPublicWifiAccounts } from '../../store/reducers';
import { OnDestroyHookDirective } from '../../shared/hooks';

@Component({
  selector: 'mprd-public-wifi-account-list',
  templateUrl: './public-wifi-account-list.component.html',
  styleUrls: ['./public-wifi-account-list.component.css'],
})
export class PublicWifiAccountListComponent
  extends OnDestroyHookDirective
  implements OnInit
{
  total: number;
  alreadyUsed: number;
  remaining: number;

  constructor(private store: Store<ApplicationState>) {
    super();
  }

  ngOnInit() {
    this.addSubscription(
      this.store.select(getPublicWifiAccounts).subscribe((accounts) => {
        if (accounts) {
          this.total = accounts.length;
          this.alreadyUsed = 0;
          this.remaining = 0;
          accounts.forEach((account) => {
            if (account.login === account.technicalLoginId) {
              this.remaining += 1;
            } else {
              this.alreadyUsed += 1;
            }
          });
        }
      }),
    );
  }
}
